import React from "react";
import * as S from "./ZaiaReaction.style.js";
import { motion } from "motion/react"

const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

function ZaiaReaction({ 
  textColor, 
  text, 
  subText,
  zaiaImg, 
  separation, 
  widthimg, 
  widthText, 
  widthSubText, 
  sizeText,
  sizeSubText,
  sizeBetweenText,
  weighttext=true,
  loadingPoints=false,
  padding
}) {

  return (
    <S.ZaiaReaction
      textColor={textColor}
      separation={separation}
      widthimg={widthimg}
      $widthText={widthText}
      widthSubText={widthSubText}
      sizeText={sizeText}
      sizeSubText={sizeSubText}
      sizeBetweenText={sizeBetweenText}
      weighttext={weighttext}
      loadingpoints={loadingPoints}
      padding={padding}
    >
      {
        zaiaImg === logoZaiaLoading
        ? <div className="loader-container">
            <div className="loader-icon">
              
              <motion.div
                className="spinner"
                animate={{ rotate: 360 }}
                transition={{ duration: 1.6, repeat: Infinity, ease: "linear" }}
              />

              <div className="logo">
                <img
                  src={zaiaImg}
                  alt="Logo"
                  referrerPolicy="no-referrer"
                />
              </div>

              <motion.div
                className="orbit"
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              >
                <div className="dot" />
              </motion.div>
            </div>
          </div>
        : <img src={zaiaImg} alt={text}/>
      }
      <div className="reaction-text">
        {
          text ? <div className="zaia-reaction-text">{text}</div> : null
        }
        {
          subText ? <div className="zaia-reaction-subtext">{subText}</div> : null
        }
        {
          loadingPoints &&
          <S.ZaialoadingPoints color={textColor}>
            <div className="dot-flashing"></div>
          </S.ZaialoadingPoints>
        }
      </div>
    </S.ZaiaReaction>
  );
}

export default ZaiaReaction;
